import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_search_filter_foreign_object extends PureComponent {
  render() {
    return (
      <div className="row" id="component_search_filter_foreign_object">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Search Filter Foreign Object</h2>
              <p>
                The Filter Foreign Object allows a user to filter a search
                against a single foreign record. Foreign records are stored
                against records as an object with duplicates of set fields. The
                ID of the foreign record is stored in the "text_id” field.
              </p>

              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={true}
              />
              <InterfaceProperties
                type={"search_foreign_object_select"}
                name={"filter foreign object"}
                dataNameDefault={'"object_my_obj"'}
                searchGroup={true}
                padding={true}
                hide={true}
                order={true}
                tabIndex={true}
                displayName={true}
                sourceUrl={true}
                sourceSave={true}
                properties={[
                  {
                    property: "search_display_primary",
                    description:
                      "Fields displayed in the primary text line of the search results.",
                    defaults: '["text_field1", "text_field2"]'
                  },
                  {
                    property: "search_display_secondary",
                    description:
                      "Fields displayed in the secondary text line of the search results.",
                    defaults: '["text_field1", "text_field2"]'
                  },
                  {
                    property: "search_icon",
                    description:
                      "Icon choosen from the material icon font displayed agaist the search results.",
                    defaults: '"headset_mic"'
                  },
                  {
                    property: "search_icon_color",
                    description:
                      "Icon foreground color dispalyed in search results.",
                    defaults: '"#FFFFFF"'
                  },
                  {
                    property: "search_icon_color_background",
                    description:
                      "Icon background color dispalyed in search results.",
                    defaults: '"#1976D2"'
                  },
                  {
                    property: "search_icon_user_avatar",
                    description:
                      'Use the "user" avatar instead of a static icon. The user avatar is a circle with the first inital of "text_first_name" and "text_last_name".',
                    defaults: "true, false default false"
                  }
                ]}
              />

              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Record Filter Foreign Object Example</h2>
            </section>
            <section>
              <h3>Example 1: Filter Foreign Object</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">
                      "search_foreign_object_select"
                    </span>
                    ,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"object_my_field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"My Object"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_group"</span>:{" "}
                  <span className="jsonY">"search_group_1"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"source_url_api"</span>:{" "}
                  <span className="jsonY">"client"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"source_save"</span>: [
                </div>
                <div className="i2">
                  <span className="jsonY">"text_first_name"</span>,
                </div>
                <div className="i2">
                  <span className="jsonY">"text_last_name"</span>
                </div>
                <div className="i1">],</div>
                <div className="i1">
                  <span className="jsonG">"search_display_primary"</span>: [
                </div>
                <div className="i2">
                  <span className="jsonY">"text_first_name"</span>,
                </div>
                <div className="i2">
                  <span className="jsonY">"text_last_name"</span>
                </div>
                <div className="i1">],</div>
                <div className="i1">
                  <span className="jsonG">"search_display_secondary"</span>: [
                </div>
                <div className="i2">
                  <span className="jsonY">"text_first_name"</span>,
                </div>
                <div className="i2">
                  <span className="jsonY">"text_last_name"</span>
                </div>
                <div className="i1">],</div>
                <div className="i1">
                  <span className="jsonG">"search_icon_user_avatar"</span>:{" "}
                  <span className="jsonP">false</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_icon"</span>:{" "}
                  <span className="jsonY">"headset_mic"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_icon_color"</span>:{" "}
                  <span className="jsonY">"#FFD54F"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_icon_color_background"</span>:{" "}
                  <span className="jsonY">"#1976d2"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"show_button"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"width"</span>:{" "}
                  <span className="jsonY">"100%"</span>,
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_search_filter_foreign_object;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_search_filter_foreign_object.js